<section id="list-wrapper">
  <ng-container *ngIf="cardsList?.length">
    <ng-container *ngFor="let summaryCard of cardsList; trackBy: trackByFn">
      <summary-card [summaryCard]="summaryCard" [iconType]="iconType" (selection)="onSelection($event)"> </summary-card>
    </ng-container>
  </ng-container>
</section>
